export default "__VITE_ASSET__CZOH1p6h__"